import React from 'react';
import { BookOpen, CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const volumes = [{
    title: 'Volume 1: The Foundation',
    desc: 'Business structure, pricing models, and legal templates to protect yourself.'
  }, {
    title: 'Volume 2: Client Acquisition',
    desc: 'Marketing strategies, lead generation, and social media frameworks.'
  }, {
    title: 'Volume 3: The Sales System',
    desc: 'Consultation scripts, objection handling, and closing techniques.'
  }, {
    title: 'Volume 4: Programming & Delivery',
    desc: 'Workout templates, periodization models, and client tracking sheets.'
  }, {
    title: 'Volume 5: Client Retention',
    desc: 'Onboarding processes, check-in systems, and community building.'
  }, {
    title: 'Volume 6: Scaling Up',
    desc: 'Hiring, delegating, and transitioning to online or hybrid models.'
  }];
  const includes = ['Step-by-step implementation guides', 'Ready-to-use templates (Word/Excel/PDF)', 'Customizable scripts for every scenario', 'Checklists to ensure nothing is missed', 'Lifetime updates to all materials'];
  return <section className="bg-black py-16 md:py-24" data-id="element-252">
      <div className="max-w-5xl mx-auto px-4" data-id="element-253">
        {/* Product Reveal Header */}
        <div className="bg-nero-card border-t-2 border-soft-gold rounded-b-2xl p-8 md:p-12 text-center mb-16 shadow-2xl" data-id="element-254">
          <span className="inline-block text-soft-gold text-xs md:text-sm font-bold uppercase tracking-wider mb-4" data-id="element-255">
            🏆 NEROVIX™ PROFESSIONAL MEGAPACK
          </span>
          <h2 className="text-white text-3xl md:text-5xl font-bold font-playfair mb-4" data-id="element-256">
            PT Business & Coaching Kit
          </h2>
          <p className="text-soft-gold italic text-lg md:text-xl mb-8 font-playfair" data-id="element-257">
            The complete system that turns a good trainer into a PT business
            that actually pays.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8" data-id="element-258">
            <div className="bg-nero-mid border border-nero-border px-4 py-2 rounded-lg" data-id="element-259">
              <p className="text-soft-gold text-sm font-medium" data-id="element-260">
                6 Volumes + 6 Bonuses — Starter → Professional
              </p>
            </div>
            <div className="bg-nero-mid border border-nero-border px-4 py-2 rounded-lg" data-id="element-261">
              <p className="text-soft-gold text-sm font-medium" data-id="element-262">
                300+ pages. Every gap in your business. Solved.
              </p>
            </div>
          </div>

          <p className="text-secondary-text text-xs md:text-sm uppercase tracking-widest" data-id="element-263">
            Consultation · Onboarding · Screening · Programming · Coaching ·
            Sales
          </p>
        </div>

        {/* Volumes Grid */}
        <h3 className="text-soft-gold text-2xl md:text-3xl font-bold text-center mb-10 font-playfair" data-id="element-264">
          💪 6 COMPLETE VOLUMES
        </h3>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-265">
          {volumes.map((vol, idx) => <div key={idx} className="bg-nero-card border border-nero-border rounded-xl p-6 hover:border-soft-gold transition-colors" data-id="element-266">
              <BookOpen className="w-8 h-8 text-soft-gold mb-4" data-id="element-267" />
              <h4 className="text-white font-bold text-lg mb-2" data-id="element-268">{vol.title}</h4>
              <p className="text-secondary-text text-sm leading-relaxed" data-id="element-269">
                {vol.desc}
              </p>
            </div>)}
        </div>

        {/* Gold Includes Block */}
        <div className="bg-soft-gold text-black rounded-xl p-8 md:p-10 shadow-[0_0_40px_rgba(212,175,55,0.15)]" data-id="element-270">
          <h4 className="text-xl md:text-2xl font-bold mb-6 text-center md:text-left" data-id="element-271">
            Every volume includes:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-272">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-273">
                <CheckCircle2 className="w-5 h-5 text-black shrink-0" data-id="element-274" />
                <span className="font-medium" data-id="element-275">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}